<app-page-header
  [title]="addParty ? 'Nuevo socio' : pageHeaderTitle"
  [mobileTitle]="addParty ? 'Nuevo socio' : pageHeaderTitle"
  [icon]="headerShowBack || addParty ? undefined : 'fas fa-users'"
  [showBack]="headerShowBack || addParty"
  [unifiedOnMobile]="headerShowBack || addParty"
  (back)="onPageHeaderBack()">
  @if (appSettings.isMobile() && canDeleteFromHeader && overview?.showAddClaim()) {
    <button headerExtra type="button" class="btn btn-outline-danger btn-xs"
      [disabled]="isHeaderActionSaving"
      (click)="deleteFromHeader()"
      title="Eliminar">
      <i class="fas fa-trash me-1"></i>Eliminar
    </button>
  }
</app-page-header>

<app-mobile-footer [visible]="showMobileFooter">
  @if (showListMobileActions) {
    <input type="search"
      class="form-control mobile-footer-search"
      placeholder="Buscar socio, RUT..."
      [ngModel]="searchQuery"
      (ngModelChange)="searchQuery = $event; applyListFilters()">
    <button type="button" class="btn btn-outline-secondary btn-sm mobile-footer-filter"
      [class.btn-outline-primary]="activeAdvancedFilters().length > 0"
      (click)="advFilter.toggleOpen()">
      <i class="fas fa-filter me-1"></i>Filtros
      @if (activeAdvancedFilters().length > 0) {
        <span class="badge bg-primary ms-1">{{ activeAdvancedFilters().length }}</span>
      }
    </button>
  } @else {
    @if (headerPrimaryAction) {
      <button type="button" class="btn btn-sm"
        [class.btn-success]="headerPrimaryAction === 'finalize'"
        [class.btn-primary]="headerPrimaryAction !== 'finalize'"
        [disabled]="isHeaderActionSaving"
        (click)="runHeaderPrimaryAction()">
        @if (isHeaderActionSaving) {
          <span class="spinner-border spinner-border-sm me-1"></span>
        }
        {{ headerPrimaryLabel }}
      </button>
    }
  }
</app-mobile-footer>

@if(addParty){
<app-add-party #addPartyComp (headerEditorActionChange)="partyHeaderAction = $event" (onClose)="changeAddParty($event)"></app-add-party>
}@else{

<app-advanced-filter #advFilter [fields]="advancedFilterFields" [showTrigger]="false"
  (filtersChange)="onAdvancedFiltersChange($event)">
</app-advanced-filter>

<div class="row">
  <!-- Columna Izquierda: Filtros y Lista -->
  @if (!isClaimModeActive && !isPortalUser() && !(appSettings.isMobile() && partyOut)) {
  <div [class]="appSettings.isMobile() ? 'col-12' : 'col-md-3'">
    <app-party-list
      [parties]="partiesData"
      [isLoading]="isLoading"
      [selectedUuid]="partyOut?.uuid ?? null"
      [isPortalUser]="isPortalUser()"
      [ngPartiesData]="ngPartiesData"
      [activeAdvancedFiltersCount]="activeAdvancedFilters().length"
      [(partiesSelected)]="partiesSelected"
      (selectParty)="showOverviewParty($event)"
      (newParty)="openNewParty()"
      (filtersChange)="changeSelect()"
      (openFilters)="advFilter.toggleOpen()">
    </app-party-list>
  </div>
  }

  <!-- Columna Derecha: Detalle -->
  <div [class]="isClaimModeActive || isPortalUser() || (appSettings.isMobile() && partyOut) ? 'col-md-12' : 'col-md-9'">
    @if(partyOut){
    <app-party-overview #overview [data]="partyOut" (onUpdate)="getParties()"
      (claimModeChange)="isClaimModeActive = $event"
      (headerContextChange)="onHeaderContext($event)"
      (onClose)="isClaimModeActive = false; resetPageHeader(); closeOverviewParty($event)"></app-party-overview>
    } @else if (isLoading) {
    <div class="party-overview-skeleton">
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <span class="nav-link active placeholder-glow">
            <span class="placeholder col-10 bg-gray-500"></span>
          </span>
        </li>
        <li class="nav-item">
          <span class="nav-link placeholder-glow">
            <span class="placeholder col-8 bg-gray-500"></span>
          </span>
        </li>
      </ul>
      <div class="panel p-4 rounded-0 rounded-bottom">
        <div class="placeholder-glow">
          <div class="row g-3 mb-3">
            <div class="col-6 col-md-2">
              <span class="placeholder placeholder-sm col-6 bg-gray-500 d-block mb-2"></span>
              <span class="placeholder col-12 bg-gray-500"></span>
            </div>
            <div class="col-12 col-md-6">
              <span class="placeholder placeholder-sm col-5 bg-gray-500 d-block mb-2"></span>
              <span class="placeholder col-12 bg-gray-500"></span>
            </div>
            <div class="col-6 col-md-4">
              <span class="placeholder placeholder-sm col-7 bg-gray-500 d-block mb-2"></span>
              <span class="placeholder col-12 bg-gray-500"></span>
            </div>
          </div>
          <div class="row g-3 mb-3">
            <div class="col-6 col-md-2">
              <span class="placeholder placeholder-sm col-8 bg-gray-500 d-block mb-2"></span>
              <span class="placeholder col-12 bg-gray-500"></span>
            </div>
            <div class="col-6 col-md-4">
              <span class="placeholder placeholder-sm col-5 bg-gray-500 d-block mb-2"></span>
              <span class="placeholder col-12 bg-gray-500"></span>
            </div>
            <div class="col-12 col-md-6">
              <span class="placeholder placeholder-sm col-4 bg-gray-500 d-block mb-2"></span>
              <span class="placeholder col-12 bg-gray-500"></span>
            </div>
          </div>
          <div class="row g-3">
            <div class="col-12 col-md-6">
              <span class="placeholder placeholder-sm col-4 bg-gray-500 d-block mb-2"></span>
              <span class="placeholder col-12 bg-gray-500"></span>
            </div>
            <div class="col-12 col-md-6">
              <span class="placeholder placeholder-sm col-4 bg-gray-500 d-block mb-2"></span>
              <span class="placeholder col-12 bg-gray-500"></span>
            </div>
          </div>
          <div class="d-flex justify-content-end gap-2 mt-4 pt-3 border-top">
            <a class="btn btn-primary bg-gray-500 border-gray-500 disabled placeholder col-2" aria-disabled="true"></a>
            <a class="btn btn-primary bg-gray-500 border-gray-500 disabled placeholder col-2" aria-disabled="true"></a>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-6 col-md-12 mb-3 mb-xl-0">
          <div class="panel h-100">
            <div class="panel-header p-3 mb-0 bg-none placeholder-glow">
              <span class="placeholder placeholder-sm col-4 bg-gray-500"></span>
            </div>
            <div class="panel-body placeholder-glow px-3 pb-3">
              <span class="placeholder placeholder-sm col-3 bg-gray-500 me-2"></span>
              <span class="placeholder placeholder-sm col-4 bg-gray-500 me-2"></span>
              <span class="placeholder placeholder-sm col-2 bg-gray-500"></span>
              <div class="mt-3">
                <span class="placeholder col-12 bg-gray-500 mb-2 d-block"></span>
                <span class="placeholder col-12 bg-gray-500 mb-2 d-block"></span>
                <span class="placeholder col-8 bg-gray-500 d-block"></span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-6 col-md-12">
          <div class="panel h-100">
            <div class="panel-header p-3 mb-0 bg-none placeholder-glow">
              <span class="placeholder placeholder-sm col-5 bg-gray-500"></span>
            </div>
            <div class="panel-body placeholder-glow px-3 pb-3">
              <span class="placeholder placeholder-sm col-3 bg-gray-500 me-2"></span>
              <span class="placeholder placeholder-sm col-3 bg-gray-500 me-2"></span>
              <span class="placeholder placeholder-sm col-2 bg-gray-500"></span>
              <div class="mt-3">
                <span class="placeholder col-12 bg-gray-500 mb-2 d-block"></span>
                <span class="placeholder col-12 bg-gray-500 mb-2 d-block"></span>
                <span class="placeholder col-7 bg-gray-500 d-block"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    } @else if (!appSettings.isMobile() || isPortalUser()) {
    <div class="panel">
      <div class="panel-body d-flex flex-column align-items-center justify-content-center text-center p-5"
        style="min-height: 400px;">
        <div class="mb-3 p-4 rounded-circle bg-light d-inline-flex align-items-center justify-content-center"
          style="width: 80px; height: 80px;">
          <i class="fas fa-user-tag text-info fa-2x"></i>
        </div>
        @if (isPortalUser()) {
        <h4 class="text-muted fw-bold mb-2">Sin socio vinculado</h4>
        <div class="text-muted small">Su usuario no tiene un socio asignado. Contacte al administrador.</div>
        } @else {
        <h4 class="text-muted fw-bold mb-2">No hay selección</h4>
        <div class="text-muted small">Selecciona un socio de la lista para ver el detalle y gestionar su información.
        </div>
        }
      </div>
    </div>
    }
  </div>
</div>

}

<!-- Modals -->
<ng-template #preview let-c="close" let-d="dismiss" let-modal>
  <div class="modal-header">
    <a [href]="pdfSrc" class="btn btn-success btn-sm" target="_blank">Abrir en nueva pestaña</a>
    <span (click)="d('Cross click')" type="button" class="btn-close bt-xs" data-dismiss="modal" tabindex="8">
    </span>
  </div>
  <div class="modal-body">
    @if (pdfSrc) {
    <iframe [src]="pdfSrc" width="100%" height="600px"></iframe>
    }
  </div>
</ng-template>

<ng-template #modalForm let-c="close" let-d="dismiss" let-modal>
  <div class="modal-header">
    <h4 class="modal-title">{{titleModal}}</h4>
    <span (click)="d('Cross click')" type="button" class="btn-close bt-xs" data-dismiss="modal" tabindex="8">
    </span>
  </div>
  <div class="modal-body">
    <div class="panel-body panel-form p-2">
      <form [formGroup]="formparty">
        <ng-content></ng-content>
      </form>
    </div>
  </div>
</ng-template>